module.exports = __webpack_public_path__ + "static/media/18.f22b681c.jpg";